/*
 * Parses the /Article/caq response into the card shape the renderer expects:
 * [{ id, question, answer }]. Returns an empty array for a missing or malformed
 * payload.
 */

function parseCaqCards(data) {
    var parsed;
    try {
        parsed = (typeof data === 'string') ? JSON.parse(data) : data;
    } catch (e) {
        return [];
    }

    var list = parsed && parsed.commonly_asked_questions;
    if (!Array.isArray(list)) {
        return [];
    }

    return list
        .map(function(item, i) {
            return {
                id: i + 1,
                question: ((item && item.question) || '').trim(),
                answer: ((item && item.answer_preview) || '').trim()
            };
        })
        .filter(function(card) {
            return card.question && card.answer;
        });
}

module.exports = {
    parseCaqCards: parseCaqCards
};